import React from "react";

import styles from "./Canpar.module.css";

function Canpar({ data }) {
  return (
    <>
      {data && (
        <div className={styles.container}>
          <h2>Canpar Rate</h2>
          <div className={styles.frightRate}>
            <div className={styles.subHeadHead}>Fright Rate</div>
            <div className={styles.subHeadRate}>${data.freightCharge}</div>
          </div>
          <div className={styles.subTotalRate}>
            <h3>Sub Total</h3>
            <div className={styles.subContainer}>
              <div className={styles.subHeadHead}>Fuel Surcharge</div>
              <div className={styles.subHeadRate}>${data.fuelCharge}</div>
            </div>
            {data?.ra_charge > 0 && (
              <div className={styles.subContainer}>
                <div className={styles.subHeadHead}>Residential Charges</div>
                <div className={styles.subHeadRate}>${data.ra_charge}</div>
              </div>
            )}
            <div className={styles.subContainer}>
              <div className={styles.subHeadHead}>Taxes</div>
              <div className={styles.subHeadRate}>${data.taxCharge}</div>
            </div>
          </div>
          <div className={styles.total}>${data.total}</div>
        </div>
      )}
      {!data && (
        <div className={styles.container}>
          <div>
            <h2>Canpar Rate</h2>
            <h3
              style={{
                margin: "12px 0",
              }}
            >
              Rate not available
            </h3>
          </div>
        </div>
      )}
    </>
  );
}

export default Canpar;
